import React from 'react';
import { TextInput, ReferenceInput, AutocompleteInput, NumberInput, DateInput, BooleanInput } from 'react-admin';

import Edit from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import BudgetTypeInput from './inputs/BudgetTypeInput';

const optionText = choice => (choice && choice.name ? choice.name : '');

const BudgetEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <ReferenceInput label="Customer" source="customer_id" reference="customers" sort={{ field: 'name', order: 'ASC' }} allowEmpty>
                <AutocompleteInput optionText={optionText} />
            </ReferenceInput>
            <ReferenceInput label="Project" source="project_id" reference="projects" sort={{ field: 'name', order: 'ASC' }} allowEmpty>
                <AutocompleteInput optionText={optionText} />
            </ReferenceInput>

            <BudgetTypeInput />

            <TextInput source="label" />
            <TextInput source="alias" />
            <TextInput source="description" />

            <NumberInput source="hours_included" />
            <NumberInput source="amount" />

            <DateInput source="start_date" />
            <DateInput source="end_date" />

            <BooleanInput source="is_active" />
        </SimpleForm>
    </Edit>
);

export default BudgetEdit;